@if (showDrawer$ | async) {
    <div [@slideIn] class="drawer-container">
        <div class="drawer-content">
            <div class="drawer-heading">
                <span>{{ "navigation_title" | translate }}</span>
                <div class="close-drawer-btn" (click)="closeDrawer()">×</div>
            </div>
            @for (block of blocks(); track $index; let i = $index) {
                <web-navigation-block-item [entity]="block" [index]="i" [selectedEntity]="selectedEntity()" />
            }
        </div>
    </div>
}
